/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Min_Words_Per_Line_LabelInputs */

const en_style_guide_manager_min_words_per_line_label = /** @type {(inputs: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum Words/Line`)
};

const fr_style_guide_manager_min_words_per_line_label = /** @type {(inputs: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mots minimum par ligne`)
};

const de_style_guide_manager_min_words_per_line_label = /** @type {(inputs: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestanzahl Wörter pro Zeile`)
};

const it_style_guide_manager_min_words_per_line_label = /** @type {(inputs: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero minimo di parole/riga`)
};

const ru_style_guide_manager_min_words_per_line_label = /** @type {(inputs: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальное количество слов в строке`)
};

const es_style_guide_manager_min_words_per_line_label = /** @type {(inputs: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo de palabras/línea`)
};

const zh_cn2_style_guide_manager_min_words_per_line_label = /** @type {(inputs: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行最少字数`)
};

const ja_style_guide_manager_min_words_per_line_label = /** @type {(inputs: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小単語数/行`)
};

const hi_style_guide_manager_min_words_per_line_label = /** @type {(inputs: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम शब्द/पंक्ति`)
};

const pt_pt2_style_guide_manager_min_words_per_line_label = /** @type {(inputs: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número mínimo de palavras por linha`)
};

/**
* | output |
* | --- |
* | "Minimum Words/Line" |
*
* @param {Style_Guide_Manager_Min_Words_Per_Line_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_min_words_per_line_label = /** @type {((inputs?: Style_Guide_Manager_Min_Words_Per_Line_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Min_Words_Per_Line_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_min_words_per_line_label(inputs)
	if (locale === "de") return de_style_guide_manager_min_words_per_line_label(inputs)
	if (locale === "it") return it_style_guide_manager_min_words_per_line_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_min_words_per_line_label(inputs)
	if (locale === "es") return es_style_guide_manager_min_words_per_line_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_min_words_per_line_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_min_words_per_line_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_min_words_per_line_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_min_words_per_line_label(inputs)
	return en_style_guide_manager_min_words_per_line_label(inputs)
});